import api from "@/router/api";

export default {
  /**
   * Consulta o termo de uso e a política de privacidade vigentes.
   * Se o usuário estiver autenticado, retorna também o status de concordância e precisaConcordar.
   */
  async obterTermoVigente() {
    try {
      const response = await api.get("/termos/vigente");
      if (response.status === 204 || !response.data) {
        return null;
      }
      return response.data;
    } catch (error) {
      if (error?.response?.status === 204) {
        return null;
      }
      console.error("Erro ao obter termo vigente:", error);
      throw error;
    }
  },

  /**
   * Registra a concordância (ou revogação) do usuário logado.
   * @param {boolean} concorda - true para concordar, false para revogar
   * @param {string|null} versao - versão opcional com a qual está concordando
   */
  async registrarConcordancia(concorda = true, versao = null) {
    const payload = { concorda };
    if (versao) {
      payload.versao = versao;
    }
    const response = await api.post("/termos/concordancia", payload);
    return response.data;
  },

  /**
   * Cadastra uma nova versão do termo de uso e política de privacidade.
   * Acesso restrito a ADMINISTRADOR / PREX.
   * @param {FormData|object} dados - pode ser FormData já montado ou objeto com os campos
   */
  async cadastrarTermo(dados) {
    let formData;
    if (dados instanceof FormData) {
      formData = dados;
    } else {
      formData = new FormData();
      if (dados.versao) formData.append("versao", dados.versao.trim());
      if (dados.exigeReaceite !== undefined) {
        formData.append("exigeReaceite", dados.exigeReaceite);
      }
      if (dados.dataPublicacao) {
        formData.append("dataPublicacao", dados.dataPublicacao);
      }
      if (dados.termoUsoPdf) {
        formData.append("termoUsoPdf", dados.termoUsoPdf);
      }
      if (dados.politicaPrivacidadePdf) {
        formData.append("politicaPrivacidadePdf", dados.politicaPrivacidadePdf);
      }
    }

    const response = await api.post("/termos", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  /**
   * Lista todos os termos cadastrados (histórico de versões).
   * @param {number} page - número da página (inicia em 0)
   * @param {number} size - tamanho da página
   */
  async listarTermos(page = 0, size = 10) {
    const response = await api.get("/termos", {
      params: { page, size },
    });
    return response.data;
  },

  /**
   * Consulta um termo específico pelo UUID.
   * @param {string} id - UUID do termo
   */
  async obterPorId(id) {
    const response = await api.get(`/termos/${id}`);
    return response.data;
  },
};

